"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPalette = exports.defaultPalette = void 0;
var tokens_1 = require("@prezzee/tokens");
exports.defaultPalette = {
    primary: {
        base: tokens_1.colors.red400,
        baseText: tokens_1.colors.white,
        hover: tokens_1.colors.red500,
        hoverText: tokens_1.colors.white,
        active: tokens_1.colors.red700,
        activeText: tokens_1.colors.white,
    },
    secondary: {
        base: tokens_1.colors.purple400,
        baseText: tokens_1.colors.white,
        hover: tokens_1.colors.purple600,
        hoverText: tokens_1.colors.white,
        active: tokens_1.colors.purple700,
        activeText: tokens_1.colors.white,
    },
    tertiary: {
        base: tokens_1.colors.blue500,
        baseText: tokens_1.colors.white,
        hover: tokens_1.colors.blue300,
        hoverText: tokens_1.colors.white,
        active: tokens_1.colors.blue700,
        activeText: tokens_1.colors.white,
    },
    text: {
        heading: tokens_1.colors.gray800,
        body: tokens_1.colors.gray600,
    },
};
// TODO: Setup deepmerge of palette input for theme
function createPalette(paletteInput) {
    console.log(paletteInput);
    return exports.defaultPalette;
}
exports.createPalette = createPalette;
//# sourceMappingURL=palette.js.map